import React, { useEffect, useState } from "react";
import Select from 'react-select'
import { Link, useNavigate } from 'react-router-dom'
import N3rveLogo from './../../../images/N3rveLogo.png'
import './Support.css'
import ReactModal from 'react-modal';
import CrossIcon from './../../../images/crossicon.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";
import Cookies from 'universal-cookie';

function SupportForm() {
  const [formSubmit, setFormSubmit] = useState(false)
  const navigate = useNavigate();
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [company, setCompany] = useState("")
  const [region, setRegion] = useState("")
  const [supportRequestPopup, setSupportRequestPopup] = useState(false)
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })

  const regionOptions = [{ value: 'South East Asia', label: 'South East Asia' },
  { value: 'East Asia', label: 'East Asia' },
  { value: 'South Asia', label: 'South Asia' },
  { value: 'China', label: 'China' }]
  const [country, setCountry] = useState("")
  const [companyType, setCompanyType] = useState("")
  const companyOptions = [{ value: 'Sole proprietorship', label: 'Sole proprietorship' },
  { value: 'C corporation', label: 'C corporation' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'Limited liability company (LLC)', label: 'Limited liability company (LLC)' }]
  const [help, setHelp] = useState("")
  const helpOptions = [{ value: 'Marketing', label: 'Marketing' },
  { value: 'Distibution', label: 'Distibution' },
  { value: 'Logistics', label: 'Logistics' },
  { value: 'Analytics', label: 'Analytics' }]
  const [phone, setPhone] = useState("")
  const [webUrl, setWebUrl] = useState("")
  const [genre, setGenre] = useState("")
  const cookies = new Cookies(null, { path: '/' });

  const genreOptions = [{ value: 'Alternative', label: 'Alternative' },
  { value: 'Audiobooks', label: 'Audiobooks' },
  { value: 'Blues', label: 'Blues' },
  { value: 'Children’s Music', label: 'Children’s Music' },
  { value: 'Classical', label: 'Classical' },
  { value: 'Comedy', label: 'Comedy' },
  { value: 'Country', label: 'Country' },
  { value: 'Dance', label: 'Dance' },
  { value: 'Electronic', label: 'Electronic' },
  { value: 'Folk', label: 'Folk' },
  { value: 'Hip hop/Rap', label: 'Hip hop/Rap' },
  { value: 'Holiday', label: 'Holiday' },
  { value: 'Inspirational', label: 'Inspirational' },
  { value: 'Jazz', label: 'Jazz' },
  { value: 'Latin', label: 'Latin' },
  { value: 'New Age', label: 'New Age' },
  { value: 'Opera', label: 'Opera' },
  { value: 'Pop', label: 'Pop' },
  { value: 'R&B/Soul', label: 'R&B/Soul' },
  { value: 'Reggae', label: 'Reggae' },
  { value: 'Rock', label: 'Rock' },
  { value: 'Spoken Word', label: 'Spoken Word' },
  { value: 'Soundtrack', label: 'Soundtrack' },
  { value: 'Vocal', label: 'Vocal' },
  { value: 'World', label: 'World' }]

  const colourStyles = {
    container: base => ({
      ...base,
      flex: 1
    }),
    control: styles => ({
      ...styles, borderColor: '#636468',
      backgroundColor: 'rgba(0,0,0,16%)',
      maxWidth: '35.18em',
      width: '100%',
      height: '3.5em',
      borderRadius: '4px',
      color: 'rgba(255, 255, 255, 1)',
      marginTop: '0.5em',
      cursor: 'pointer',
      "&:hover": {
        backgroundColor: "rgba(254,254,254,20%)"
      }
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: '#18191F',
        color: 'rgba(255, 255, 255, 1)',
        cursor: isDisabled ? 'not-allowed' : 'default',
        marginTop: '-0.3em',
        marginBottom: '-0.3em',
        cursor: 'pointer',
        "&:hover": {
          backgroundColor: 'rgba(0,0,0,100%)'
        }
      };
    },
    input: (styles) => ({
      ...styles,
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%',
      color: 'rgba(255, 255, 255, 1)'
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'rgba(255, 255, 255, 1)',
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%'
    }),
    hover: styles => ({
      backgroundColor: 'rgba(255,255,255,16%)',
    })
  };

  const [catalogTracks, setCatalogTracks] = useState("")

  const catalogOptions = [{ value: '1-5', label: '1-5' },
  { value: '6-15', label: '6-15' },
  { value: '16-30', label: '16-30' },
  { value: '31-100', label: '31-100' }]

  const [monthTracks, setMonthTracks] = useState("")

  const monthOptions = [{ value: '1-5', label: '1-5' },
  { value: '6-15', label: '6-15' },
  { value: '16-30', label: '16-30' },
  { value: '31-100', label: '31-100' }]

  const [bestArtist, setBestArtist] = useState("")

  const [findUs, setFindUs] = useState("")

  const findUsOptions = [{ value: 'Website', label: 'Website' },
  { value: 'Social Media', label: 'Social Media' },
  { value: 'Email', label: 'Email' },
  { value: 'Referral', label: 'Referral' }]

  const [moreDetail, setMoreDetails] = useState("")

  const changeRegionHandler = value => {
    setRegion(value)
  }

  const changeCompanyHandler = value => {
    setCompanyType(value)
  }

  const changeHelpHandler = value => {
    setHelp(value)
  }

  const changecatalogHandler = value => {
    setCatalogTracks(value)
  }

  const changemonthtracksHandler = value => {
    setMonthTracks(value)
  }

  const changeGenreHandler = value => {
    setGenre(value)
  }

  const findUsHandler = value => {
    setFindUs(value)
  }


  const closeSupportPopup = () => {
    setSupportRequestPopup(false)
  }


  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  const LogForm = (name, email, company, companytype, help, phone, weburl, genre, catalogtracks, monthtracks, bestartist, findus, moredetails) => {

    if (cookies.get('token') !== undefined) {
      if (decodeToken(cookies.get('token')) !== null) {
        logtoWix(decodeToken(cookies.get('token')).email, "form submit", "Contact Us Page", { "desc": "User filled contact us form", "name": name, "email": email, "company": company, "companytype": companytype, "help": help, "phone": phone, "weburl": weburl, "genre": genre, "catalogtracks": catalogtracks, "monthtracks": monthtracks, "bestartist": bestartist, "findus": findus, "moredetails": moredetails })

      } else {
        logtoWix("anonymous user", "form submit", "Contact Us Page", { "desc": "User filled contact us form", "name": name, "email": email, "company": company, "companytype": companytype, "help": help, "phone": phone, "weburl": weburl, "genre": genre, "catalogtracks": catalogtracks, "monthtracks": monthtracks, "bestartist": bestartist, "findus": findus, "moredetails": moredetails })

      }
    } else {
      logtoWix("anonymous user", "form submit", "Contact Us Page", { "desc": "User filled contact us form", "name": name, "email": email, "company": company, "companytype": companytype, "help": help, "phone": phone, "weburl": weburl, "genre": genre, "catalogtracks": catalogtracks, "monthtracks": monthtracks, "bestartist": bestartist, "findus": findus, "moredetails": moredetails })

    }

  }


  useEffect(() => {
    topFunction()
  }, [])

  useEffect(() => {

  }, [moreDetail])


  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {
        !formSubmit &&
        <div style={{ backgroundColor: '#0F1923', paddingBottom: '8em', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={N3rveLogo} className="SupportNerveLogo" onClick={() => {
            setName("");
            setEmail("");
            setCompany("");
            setRegion("");
            setCountry("");
            setCompanyType("");
            setHelp("");
            setPhone("");
            setWebUrl("");
            setGenre("");
            setCatalogTracks("");
            setMonthTracks("");
            setBestArtist("");
            setFindUs("");
            setMoreDetails("");
            navigate('/')
          }}
          />
          <div className="GetInTouch">
            Get in touch for more information
          </div>

          <div className="PleaseFillForm">
            Please fill in the form below and submit it to get in touch for more <br /> information.
          </div>

          <span className="ytMonetizeFormHeader" style={{ maxWidth: '35.18em', width: '83%' }}>
            Name <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <input
            value={name}
            onChange={e => { setName(e.target.value); }}
            className='ytInputField'
            style={{ maxWidth: '34.18em', width: '80%' }}
            type='text'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            Email <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <input
            value={email}
            onChange={e => { setEmail(e.target.value); }}
            className='ytInputField'
            type='email'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            Company <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <input
            value={company}
            onChange={e => { setCompany(e.target.value); }}
            className='ytInputField'
            type='text'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            Region <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={regionOptions} value={region} onChange={changeRegionHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            Country <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <input
            value={country}
            onChange={e => { setCountry(e.target.value); }}
            className='ytInputField'
            type='text'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            Company Type <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={companyOptions} value={companyType} onChange={changeCompanyHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            How can we help? <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={helpOptions} value={help} onChange={changeHelpHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            Phone
          </span>

          <input
            value={phone}
            onChange={e => { setPhone(e.target.value); }}
            className='ytInputField'
            type='number'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            Website Url
          </span>

          <input
            value={webUrl}
            onChange={e => { setWebUrl(e.target.value); }}
            className='ytInputField'
            type='url'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            Primary genre of music <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={genreOptions} value={genre} onChange={changeGenreHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            How many tracks are in your  catalog? <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={catalogOptions} value={catalogTracks} onChange={changecatalogHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            How many tracks do you release every month? <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={monthOptions} value={monthTracks} onChange={changemonthtracksHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            Who is your best known artist?
          </span>

          <input
            value={bestArtist}
            onChange={e => { setBestArtist(e.target.value); }}
            className='ytInputField'
            type='text'
          // style={{marginLeft:'4.8em'}}
          />

          <span className="ytMonetizeFormHeader">
            How did you find us? <span style={{ color: '#E91353' }}>&nbsp;*</span>
          </span>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '83%', maxWidth: '35.18em' }}>
            <Select options={findUsOptions} value={findUs} onChange={findUsHandler}
              components={{
                IndicatorSeparator: () => null
              }}
              placeholder="Select"
              styles={
                colourStyles
              } />
          </div>

          <span className="ytMonetizeFormHeader" style={{ marginTop: '1em' }}>
            More details of how we can help
          </span>

          <textarea rows="4" cols="50" className='InputFieldbktextarea' onChange={e => { setMoreDetails(e.target.value); }} value={moreDetail} />


          {
            (name.length === 0 || email.length === 0 || company.length === 0 || region.length === 0 || country.length === 0 || region.length === 0 || country.length === 0 || companyType.length === 0 || help.length === 0 || genre.length === 0 || catalogTracks.length === 0 || monthTracks.length === 0 || findUs.length === 0) &&
            <div className="GetInTouchBtnPrelogin" style={{ cursor: 'auto', textTransform: 'none', paddingTop: '1em', paddingBottom: '1em' }}>
              Send
            </div>
          }
          {
            name.length !== 0 && email.length !== 0 && company.length !== 0 && region.length !== 0 && country.length !== 0 && region.length !== 0 && country.length !== 0 && companyType.length !== 0 && help.length !== 0 && genre.length !== 0 && catalogTracks.length !== 0 && monthTracks.length !== 0 && findUs.length !== 0 &&
            <div className="GetInTouchBtnPrelogin" style={{ textTransform: 'none', paddingTop: '1em', paddingBottom: '1em' }} onClick={() => {
              LogForm(name, email, company, companyType, help, phone, webUrl, genre, catalogTracks, monthTracks, bestArtist, findUs, moreDetail)
              setFormSubmit(true);
              setName("");
              setEmail("");
              setCompany("");
              setRegion("");
              setCountry("");
              setCompanyType("");
              setHelp("");
              setPhone("");
              setWebUrl("");
              setGenre("");
              setCatalogTracks("");
              setMonthTracks("");
              setBestArtist("");
              setFindUs("");
              setMoreDetails("")
            }}>
              Send
              <div className="PostLoginBtnOverlay" />
            </div>
          }


        </div>
      }
      {
        formSubmit &&
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#0F1923' }}>
          <img src={N3rveLogo} className="SupportNerveLogo" onClick={() => { navigate('/') }} />
          <div className="GetInTouch">
            Thanks! We’ll Get in Touch Soon
          </div>

          <span className="PleaseFillForm" style={{ marginTop: '5em' }}>
            Your message has been sent.<br />
            For any queries, reach out to us at <a href="mailto:support@n3rve.com" style={{ color: '#C7A5FF', cursor: 'pointer', textDecoration: 'none' }}>support@n3rve.com</a>
          </span>

          <div className="GetInTouchBtnPrelogin" style={{ textTransform: 'none', paddingTop: '1em', paddingBottom: '1em' }} onClick={() => { navigate('/') }}>
            Return to main
            <div className="PostLoginBtnOverlay" />
          </div>
        </div>
      }

      <ReactModal
        isOpen={supportRequestPopup}
        overlayClassName="Overlay"
        contentLabel="Example Modal"
        onRequestClose={closeSupportPopup} // closes the modal when the user presses the escape key
        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
        style={{
          content: {
            width: '34.125em',
            height: '28.125em',
            margin: 'auto',
            backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '8px',
            border: '0.5px solid rgba(255,255,255,25%)'
          }
        }}
      >
        <div className='LogoutPopupHeader' style={{ marginTop: '1em', marginBottom: '0em' }}>
          Switch Plan Payment Details
        </div>


        <div className="MfaInputHeader" style={{ marginTop: '0em' }}>
          If you switch your plan today:
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', width: '75%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '1em' }}>

            <div className='SwitchPlanPoint'>Your plan will switch right away, gaining access to new perks</div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row' }}>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className='SwitchPlanPoint'>Your plan will switch right away, gaining access to new perks</div>
              <div className='SwitchPlanPointDesc'>For the rest of this billing cycle, you’ll be on a more expensive plan. To cover the price difference for those 30 days, you’ll get a one-time charge of approximately $6.99.</div>
            </div>
          </div>
        </div>


        <div className="IUnderstandBtn" style={{ height: '3em', cursor: 'pointer', backgroundColor: '#E91353', backgroundImage: 'none', width: '90%' }}>
          Confirm Switch
          <div className="PostLoginBtnOverlay" />

        </div>
      </ReactModal>
    </div>
  )
}

export default SupportForm;